<h3 mat-dialog-title>
    <img src="assets/Thomas.png" width="40px" class="me-3  rounded-circle"/><b>Thomas</b> de LyBox<br/>
</h3>
<div mat-dialog-content>
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
    <ng-container *ngIf="step == 0">
        Bonjour {{ authenticationService.currentUser.firstname }},<br/>
        <br/>
        Aujourd'hui, je viens vous demander 1 minute de votre temps pour nous rendre un immense service.<br/>
        <br/>
        J'espère que depuis votre inscription, vous appréciez l'application LyBox et qu'elle vous a aidé à trouver de
        nouvelles pépites. 💎<br/>
        <br/>
        Vous souhaitez que le service Lybox s'améliore ?<br/>
        Donnez nous votre avis, nous prendrons le temps d'étudier toutes vos remarques.<br/>
        <br/>
        PS : 5 étoiles ça fait toujours plaisir 😉<br/>
        <br/>
        <div class="text-center">
            <a (click)="onNoClick()" class="me-5 cursor-pointer">Non merci</a>
            <button (click)="startRate()" type="button" class="btn btn-primary">
                <i class="fa fa-play me-3" aria-hidden="true"></i> Donner mon avis
            </button>
        </div>
    </ng-container>
    <ng-container *ngIf="step == 1">
        <p>
            J'espère que vous appréciez l'application LyBox et qu'elle vous a aidé à trouver
            de nouvelles pépites<br/>
            <br/>
            Aujourd'hui, nous avons besoin de vous pour construire la meilleure application
            pour vos investissement immobiliers<br/>
            Je vous demande 30 secondes pour noter l'application LyBox sur différents
            critères :<br/>
        </p>
        <div class="row">
            <div class="col-6">
                <star-rating labelText="Facilité d'utilisation *" size="large"
                             labelPosition="top" [step]="1" [numOfStars]="5"
                             (ratingChange)="onEasyClick($event)" [hoverEnabled]="true"
                             [showHalfStars]="true" [starType]="'svg'"
                             [rating]="0"></star-rating>
            </div>
            <div class="col-6">
                <star-rating labelText="Moteur de recherche *" size="large" labelPosition="top"
                             [step]="1" [numOfStars]="5"
                             (ratingChange)="onSearchClick($event)" [hoverEnabled]="true"
                             [showHalfStars]="true" [starType]="'svg'"
                             [rating]="0"></star-rating>
            </div>
            <div class="col-6">
                <star-rating labelText="Simulateur de rendement/fiscalité *" size="large"
                             labelPosition="top"
                             [step]="1" [numOfStars]="5"
                             (ratingChange)="onSimulClick($event)" [hoverEnabled]="true"
                             [showHalfStars]="true" [starType]="'svg'"
                             [rating]="0"></star-rating>
            </div>
            <div class="col-6">
                <star-rating labelText="Note générale *" size="large" labelPosition="top"
                             [step]="1" [numOfStars]="5"
                             (ratingChange)="onGeneralClick($event)" [hoverEnabled]="true"
                             [showHalfStars]="true" [starType]="'svg'"
                             [rating]="0"></star-rating>
            </div>
            <div>
                <div class="label-value">Commentaires</div>
                <textarea class="comment-text" matInput [(ngModel)]="comment"></textarea>
                <br/>
                <button (click)="onSubmit()" class="btn btn-primary mt-3 w-100">
                    Valider mon avis
                </button>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="step == 2">
        <p *ngIf="general == 5" class="text-center">

            <b>Merci pour ce super avis !</b><br/>
            <br/>
            Je suis ravi de voir que vous avez attribué 5 étoiles à LyBox<br/>
            J'ai un dernier service à vous demander : Partager cet avis 5 étoiles pour nous aider à nous développer<br/>
            Un grand merci !<br/>
            <br/>
<!--            <a target="_blank" href="https://g.page/r/CfLXR1zgHm-IEBM/review" class="rate"><img-->
<!--                src="assets/recuperer-google-avis-client.jpg" alt="Avis google"/></a>-->
<!--            <br/>-->
<!--            <a target="_blank" href="https://g.page/r/CfLXR1zgHm-IEBM/review" class="btn btn-primary mt-3">Mettre mon-->
<!--                avis 5* sur Google</a>-->
                    <a target="_blank" href="https://fr.trustpilot.com/evaluate/www.lybox.fr?stars=5" class="rate"><img src="assets/trustpilot.png" alt="Avis Trustpilot" /></a>
                    <br/>
                    <a target="_blank" href="https://fr.trustpilot.com/evaluate/www.lybox.fr?stars=5" class="btn btn-primary mt-3">Mettre mon avis 5* sur Trustpilot</a>
        </p>
        <p *ngIf="general != 5" class="text-center">
            <b>Merci pour votre avis !</b><br/>
            Nous avons bien pris en compte vos remarques et nous faisons le maximum pour améliorer l'application.<br/>
            Vos retours sont très importants pour les futurs développements et pour construire la meilleure application
            pour vos investissements immobiliers
        </p>
    </ng-container>
</div>
